<template>
  <span>
    <li v-if="authUpdating"><span class="fal fa-spinner fa-spin" /></li>
    <template v-if="isAuthenticated">
      <li>{{ authUser.name }} ({{ authUser.username }})</li>
      <li><a v-bind:href="logoutUrl">Logout</a></li>
    </template>
    <template v-else-if="loginUrl">
      <li><a v-bind:href="loginUrl">Staff Login</a></li>
    </template>
  </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      loginUrl: 'global/loginUrl',
      logoutUrl: 'global/logoutUrl',
      isAuthenticated: 'global/isAuthenticated',
    }),
    ...mapState({
      auth: (state) => state.global.auth,
      authUser: (state) => state.global.authUser,
      authUpdating: (state) => state.global.authUpdating,
    }),
  },
  created() {
    // This should be done every route change automatically.
    // this.$store.dispatch('global/fetchAuthUser')
  },
};
</script>
